"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audio25 = void 0;
var util_1 = require("./util");
var audio25 = function (event) {
    return (0, util_1.audioEvent)(event, "audio-25");
};
exports.audio25 = audio25;
